import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './styles/main.css'
import 'antd/dist/antd.css'

ReactDOM.render(<App />, document.getElementById('root'))
